import { useTranslation } from 'react-i18next';
import FormDrawer from 'components/drawers/form-drawer/form-drawer.component';
import { useAddCustomRuleForm } from 'components/forms/add-custom-rule-form/add-custom-rule-form.hooks';
import AddCustomRuleForm from 'components/forms/add-custom-rule-form/add-custom-rule-form.component';
import { useCreateRuleMutation } from 'api/ml-service/ml-service';

type AddCustomRuleDrawerProps = {
  open: boolean;
  close: () => void;
};

const AddCustomRuleDrawer = ({ open, close }: AddCustomRuleDrawerProps) => {
  const { t } = useTranslation();
  const { form } = useAddCustomRuleForm();
  const [createRule, { isLoading }] = useCreateRuleMutation();

  const handleClose = () => {
    form.reset();
    close();
  };

  const submit = async data => {
    const category = data.products[0]?.category;
    let triggerMenus = [],
      triggerGroups = [],
      triggerItems = [];

    switch (category) {
      case 'GROUP':
        triggerGroups = data.products.map(product => product.id);
        break;
      case 'ITEM':
        triggerItems = data.products.map(product => product.id);
        break;
      default:
        triggerMenus = data.products.map(product => product.id);
    }
    const rule = {
      ruleType: data.ruleType,
      triggerMenus,
      triggerGroups,
      triggerItems,
      recommendationItems: data.recommendationItemIds,
    };
    await createRule({
      rules: [rule],
    });
    handleClose();
  };

  return (
    <FormDrawer
      title={t('drawer.addCustomRuleDrawer.title')}
      open={open}
      onClose={handleClose}
      cancel={handleClose}
      onValid={submit}
      formMethods={form}
      data-testid="AddCustomRuleDrawer.FormDrawer"
      isLoading={isLoading}
    >
      <AddCustomRuleForm />
    </FormDrawer>
  );
};

export default AddCustomRuleDrawer;
